// src/app/shared/primeng.ts (ou où tu veux)

import { StepsModule } from 'primeng/steps';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CalendarModule } from 'primeng/calendar';
import { StepperModule } from 'primeng/stepper';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputOtpModule } from 'primeng/inputotp';
import { ToastModule } from 'primeng/toast';
import { SidebarModule } from 'primeng/sidebar';
import { MenuModule } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { AvatarModule } from 'primeng/avatar';
import { MultiSelectModule } from 'primeng/multiselect';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { StyleClassModule } from 'primeng/styleclass';
import { DragDropModule } from 'primeng/dragdrop';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { ImageModule } from 'primeng/image';
import { PaginatorModule } from 'primeng/paginator';
import { MessagesModule } from 'primeng/messages';
import { ChartModule } from 'primeng/chart';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { SelectModule } from 'primeng/select';
import { DropdownModule } from 'primeng/dropdown';
import { IftaLabelModule } from 'primeng/iftalabel';
import { DatePickerModule } from 'primeng/datepicker';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ProgressSpinner } from 'primeng/progressspinner';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { CarouselModule } from 'primeng/carousel';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ToolbarModule } from 'primeng/toolbar';
import { ChipModule } from 'primeng/chip';
import { EditorModule } from 'primeng/editor';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PopoverModule } from 'primeng/popover';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessageModule } from 'primeng/message';

export const primengImports = [
  PanelMenuModule,
  StepsModule,
  ButtonModule,
  FloatLabelModule,
  CalendarModule,
  StepperModule,
  InputTextModule,
  InputNumberModule,
  ToggleButtonModule,
  IconFieldModule,
  InputIconModule,
  InputOtpModule,
  ToastModule,
  SidebarModule,
  MenuModule,
  CheckboxModule,
  AvatarModule,
  MultiSelectModule,
  RatingModule,
  RippleModule,
  TableModule,
  TagModule,
  StyleClassModule,
  DragDropModule,
  InputSwitchModule,
  RadioButtonModule,
  InputGroupModule,
  InputGroupAddonModule,
  DialogModule,
  TooltipModule,
  CardModule,
  TabViewModule,
  ImageModule,
  PaginatorModule,
  MessagesModule,
  ChartModule,
  SplitButtonModule,
  SkeletonModule,
  IftaLabelModule,
  SelectModule,
  DropdownModule,
  DatePickerModule,
  AvatarModule,
  AvatarGroupModule,
  ProgressSpinner,
  BadgeModule,
  OverlayBadgeModule,
  CarouselModule,
  ConfirmPopupModule,
  AutoCompleteModule,
  ConfirmDialogModule,
  CascadeSelectModule,
  ToolbarModule,
  ChipModule,
  EditorModule,
  OverlayPanelModule,
  PopoverModule,
  ToggleSwitchModule,
  ProgressBarModule,
  MessageModule
];
